import React from "react";

// Mandatory Terms & Privacy acceptance checkbox used in public forms.
export default function TermsAcceptance({ checked, onChange, lang, testId = "terms-acceptance" }) {
  const tr = (pt, en) => (lang !== "en" ? pt : en);
  return (
    <label className="flex items-start gap-2.5 text-sm text-[#0B1D3A]/80 font-nunito cursor-pointer" data-testid={testId}>
      <input
        type="checkbox"
        required
        checked={checked}
        onChange={(e) => { e.target.setCustomValidity(""); onChange(e.target.checked); }}
        onInvalid={(e) => e.target.setCustomValidity(tr("Selecione esta caixa se pretender continuar.", "Please check this box if you want to proceed."))}
        onInput={(e) => e.target.setCustomValidity("")}
        className="mt-0.5 h-4 w-4 accent-[#005F73] shrink-0"
        data-testid={`${testId}-input`}
      />
      <span>
        {tr("Li e aceito os ", "I have read and accept the ")}
        <a href="/terms" target="_blank" rel="noreferrer" className="text-[#005F73] font-semibold underline">
          {tr("Termos e Condições", "Terms & Conditions")}
        </a>
        {tr(" e a ", " and the ")}
        <a href="/privacy" target="_blank" rel="noreferrer" className="text-[#005F73] font-semibold underline">
          {tr("Política de Privacidade", "Privacy Policy")}
        </a>
        .
      </span>
    </label>
  );
}
